module.exports = __webpack_public_path__ + "img/295.acce0662.jpg";